module.exports = __webpack_public_path__ + "img/map.905a56eb.png";